import {
  Code,
  ConnectError,
  type Interceptor,
} from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";

export function getCadendarRpcBaseUrl(configuredBaseUrl?: string) {
  return configuredBaseUrl?.replace(/\/+$/, "") || "/cadendarRpc";
}

export function getCadendarRpcErrorCode(error: unknown) {
  return ConnectError.from(error).code;
}

export function shouldRetryCadendarRpcRequest(
  failureCount: number,
  error: unknown,
) {
  const code = getCadendarRpcErrorCode(error);
  if (
    code === Code.Unauthenticated ||
    code === Code.PermissionDenied ||
    code === Code.InvalidArgument ||
    code === Code.NotFound
  ) {
    return false;
  }

  return failureCount < 2;
}

export const cadendarRpcAuthInterceptor: Interceptor = (next) => async (request) => {
  try {
    return await next(request);
  } catch (error) {
    if (getCadendarRpcErrorCode(error) === Code.Unauthenticated) {
      window.location.reload();
    }
    throw error;
  }
};

export const cadendarRpcTransport = createConnectTransport({
  baseUrl: getCadendarRpcBaseUrl(import.meta.env.VITE_CADENDAR_RPC_BASE_URL),
  interceptors: [cadendarRpcAuthInterceptor],
  fetch(input, init) {
    return globalThis.fetch(input, {
      ...init,
      credentials: "include",
    });
  },
});
